import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_168: DocMigration = {
  maxSchemaVersion: "0.0.168",
  description: "Add support for annotation linework line weight",
  apply(json: any) {
    for (const annotationId in json.annotation) {
      const annotation = json.annotation[annotationId];

      if (annotation.type === "LINEWORK") {
        const shapes = annotation.shapes || {};

        for (const shapeId in shapes) {
          shapes[shapeId].lineWeight = 1;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_168;
